export const slideSpeedIntervals = {
  slower: 5000,
  slow: 4000,
  normal: 3000,
  fast: 2000,
  faster: 1000,
};

export const BASE_SLIDE_SHOW_HEIGHT = 395;
export const FOOTER_HEIGHT = 66;

export const SLIDESHOW_CONST = {
  EM: 'em',
  PX: 'px',
  VH: 'vh',
  DIRECTION:{
    RIGHT:'right',
    LEFT:'left'
  },
  CSS_CONSTS:{
    ABSOLUTE:'absolute',
    JUSTIFY_CONTENT:{
      END:'end',
      CENTER:'center',
      START:'start'
    },
    OBJECT_FIT:{
      COVER: 'cover',
      UNSET: 'unset',
      CONTAIN: 'contain',
    }
  },
  SLIDE_TYPE:{
    CUSTOM:'custom'
  },
  SLIDESHOW_NAVIGATION_DIRECTION_LABELS:{
    PREVIOUS:'Previous',
    NEXT:'Next',
  },
  SLIDESHOW_ARIA_LABEL: 'Carousel Component',
  SLIDESHOW_NAVIGATION_LABELS: {
    THUMBNAILS: 'thumbnails',
    DOTS: 'dots',
    NONE: 'node',
  },
  SLIDESHOW_ARROW_COLOR: {
    LIGHT: 'light',
    DARK: 'dark',
  },
  SLIDESHOW_ARROW_TYPE: {
    HIDE: 'hide',
    RIGHT: 'right',
    LEFT: 'left',
  },
  SLIDESHOW_ARROW_SHAPE: {
    ARROW: 'arrow',
    CHEVRON:'chevron',
    CIRCULAR:'circular'
  },
  SLIDESHOW_SPOTLIGHT_TYPE: {
    SINGLE: 'single',
    SLIDE: 'slide',
    CENTER: 'center',
  },
  SLIDESHOW_CAPTION_POSITION: {
    LEFT: 'left',
    RIGHT: 'right',
    BOTTOM: 'bottom',
  },
  SLIDESHOW_CAPTION_TEXT_ALIGNMENT: {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
  },

  SLIDESHOW_CAPTION_TEXT_POSITION: {
    TOP: 'top',
    MIDDLE: 'middle',
    BOTTOM: 'bottom',
  },
  SLIDESHOW_PLAYBACK_SPEED: {
    SLOWER: 'slower',
    SLOW: 'slow',
    NORMAL: 'normal',
    FAST: 'fast',
    FASTER: 'faster',
  },
  VIDEO_EVENTS:{
    ON_ENDED:'onEnded',
    ON_ERROR:'onError',
    ON_PAUSE:'onPause',
    ON_PLAY:'onPlay',
    ON_SEEKED:'onSeeked',
    ON_START:'onStart',
    ON_TIME_UPDATE:'onTimeUpdate',
  },
  LOADING_MESSAGES:{
    PREPARING:'Preparing...',
    PROCESSING:'Processing...',
    ENCODING:'Encoding...',
    LOADING:'Loading...',
  },
  MISC:{
    PROCESSING:'processing',
  }
};
